import type { apiClient } from '~/shared/api/data-ingestion-api'

/**
 * Typecast wrapper for AuditEvent that includes EOB-specific fields
 * not yet in the OpenAPI spec (payment_summary, patient_claims).
 */
export type EobAuditEvent = apiClient.AuditEvent & {
  payment_summary?: apiClient.PaymentSummaryResponse
  patient_claims?: apiClient.PatientClaimResponse[]
}

/** Cast a raw AuditEvent to EobAuditEvent for EOB transform functions */
export function asEobEvent(event: apiClient.AuditEvent): EobAuditEvent {
  return event as EobAuditEvent
}

/** Event types that carry payment_summary data */
const PAYMENT_SUMMARY_EVENT_TYPES = new Set([
  'eob_payment_deposit',
  'eob_duplication',
  'eob_payment_summary_updated',
])

/**
 * Find the most recent previous event with payment_summary data across all EOB steps.
 * Scans filteredEvents[0..index-1] backwards.
 */
export function findPreviousPaymentSummaryEvent(
  filteredEvents: apiClient.AuditEvent[],
  index: number,
): EobAuditEvent | null {
  for (let i = index - 1; i >= 0; i--) {
    const e = filteredEvents[i]
    if (PAYMENT_SUMMARY_EVENT_TYPES.has(e.event_type)) {
      const eob = asEobEvent(e)
      if (eob.payment_summary) return eob
    }
  }
  return null
}
